export interface TabPermission {
  capability: string;
  label: string;
  app_code: string;
  min_tier?: string;
}

export const FALLBACK_TABS: TabPermission[] = [
  { capability: "crm.companies", label: "Companies", app_code: "crm", min_tier: "starter" },
  { capability: "crm.leads", label: "Leads", app_code: "crm", min_tier: "starter" },
  { capability: "crm.agreements", label: "Agreements", app_code: "crm", min_tier: "enterprise" },
  { capability: "crm.products", label: "Products", app_code: "crm", min_tier: "starter" },
  { capability: "crm.opportunities", label: "Opportunities", app_code: "crm", min_tier: "starter" },
  { capability: "crm.quotes", label: "Quotes", app_code: "crm", min_tier: "professional" },
  { capability: "crm.orders", label: "Orders", app_code: "crm", min_tier: "professional" },
  { capability: "crm.documents", label: "Template Designer", app_code: "crm", min_tier: "professional" },
  { capability: "crm.invoices", label: "Invoices", app_code: "crm", min_tier: "enterprise" },
  { capability: "crm.sales_cycle", label: "Sales cycle", app_code: "crm", min_tier: "professional" },
  { capability: "crm.support", label: "Support", app_code: "crm", min_tier: "professional" },
  { capability: "crm.forecast", label: "Forecast & KPI", app_code: "crm", min_tier: "professional" },
  { capability: "crm.dashboard.design", label: "Dashboards", app_code: "crm", min_tier: "professional" },
  { capability: "crm.app.design", label: "App designer", app_code: "crm", min_tier: "enterprise" },
  { capability: "crm.field_options", label: "Field options", app_code: "crm", min_tier: "starter" },
  { capability: "timesheet.entries", label: "Timesheet", app_code: "timesheet", min_tier: "enterprise" },
  { capability: "expense.reports", label: "Expense", app_code: "expense", min_tier: "enterprise" },
];
